import { getCompanyUsers } from "@/api/userCenter/company"

export default {
  provide() {
    return {
      curCompanyUsers: this.curCompanyUsers
    }
  },
  data() {
    return {
      curCompanyUsers: [],
      curRequestCompanyUserId: null
    }
  },
  computed: {
    companyId() {
      return this.$store.getters.userInfo?.companyId
    }
  },
  created() {
    this.refreshCurrentCompanyUsers() // 需要有当前企业
  },
  methods: {
    refreshCurrentCompanyUsers(companyId = this.companyId) {
      if (!companyId || companyId === this.curRequestCompanyUserId) {
        return
      }
      // 为了防止"短时间内进行多次请求,后面发起的请求更早响应导致数据不准确"的问题
      this.curRequestCompanyUserId = companyId
      getCompanyUsers({ companyId }).then(users => {
        if (this.curRequestCompanyUserId === companyId) {
          this.curCompanyUsers.length = 0
          this.curCompanyUsers.push(...users)
        }
      })
    }
  }
}
